<template>
  <form @submit.prevent="submit">
    <dt-modal v-model="isVisible">
      <div slot="header">
        <h4 class="modal-title">
          Confirm Delete
        </h4>
      </div>
      <div slot="body">
        <div class="row">
          <div class="form-group col-md-12">
            <p>Are you sure you wish to Delete this {{tag}}?</p>
          </div>
        </div>
      </div>
      <div slot="footer">
        <button
          type="button"
          class="btn btn-light"
          @click="close()"
        >Cancel</button>
        <button
          type="submit"
          class="btn btn-primary"
        >Delete</button>
      </div>
    </dt-modal>
  </form>
</template>
<script>
import DtModal from '@/components/utilities/modal/dt-modal.vue'
export default {
  name: 'confirm-delete',
  components: {
    DtModal
  },
  props: {
    value: {
      type: Boolean
    },
    tag: String
  },
  computed: {
    isVisible: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    close() {
      this.$emit('closing')
    },
    submit() {
      this.$emit('delete')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/contacts/forms/confirm-delete.vue